/* ***** ----------------------------------------------- ***** **
** ***** Utilities JS
** ***** ----------------------------------------------- ***** */

/* global jQuery, Main */
(function($){
	'use strict';

	Main.modules.utilities = function() {

		var windowWidth = $(window).width(),
			tabletWidth = 768,
			mediumWidth = 960,
			desktopWidth = 1150,

			isMobileWidth = function() {
				return (windowWidth < tabletWidth ? true : false);
			},

			isTabletWidth = function() {
				return (windowWidth >= tabletWidth && windowWidth < desktopWidth ? true : false);
			},

			isMediumWidth = function() {
				return (windowWidth >= tabletWidth && windowWidth < mediumWidth ? true : false);
			},

			isDesktopWidth = function() {
				return (windowWidth >= desktopWidth ? true : false);
			};

		return {
			init: function() {},
			isMobileWidth: isMobileWidth,
			isTabletWidth: isTabletWidth,
			isMediumWidth: isMediumWidth,
			isDesktopWidth: isDesktopWidth
		}
		
	};

})(jQuery);